import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  AppBar,
  Toolbar,
  TextField,
  Button,
  IconButton,
  Paper,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Container,
  CssBaseline,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Badge,
  InputAdornment,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  AccountCircle,
  Close,
  Vidiblity,
  Visibility,
  VisibilityOff,
} from "@material-ui/icons";
import LanguageToggleMenu from "../utils/languagetoggle_menu.jsx";
import { withLocalize, Translate } from "react-localize-redux";
import { useSnackbar } from "notistack";

import { useHistory } from "react-router-dom";
import { AdminService } from "./../utils/web_config";
import {TransportService,FinanceService} from "./../utils/web_config_2";

import LogoWhite from "./../assets/img/logo_white.svg";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  paper: {
    padding: 15,
  },
  btn:{
    textTransform:'capitalize'
  }
}));

function Login(props) {
  const classes = useStyles();
  const history = useHistory();

  const [confirming, setConfirming] = useState(false);


  const [username, setUsername] = useState({ value: "", error: "" });
  const [password, setPassword] = useState({ value: "", error: "" });
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [logging, setLogging] = useState(false);
  const [passSecure, setPassSecure] = useState(true);

  const [expired, setExpired] = useState(false);


  useEffect(() => {
    var ex = history?.location?.state?.expired;
    if (ex != null) {
      history.replace(history.location.pathname);
      localStorage.removeItem("nx_cent");
      localStorage.removeItem("nx_op");
      localStorage.removeItem("nx_ag");

      localStorage.removeItem("profile");
      localStorage.removeItem("agent_profile");
      setExpired(true);
    }

    const data1 = localStorage.getItem("nx_cent");
    const data2 = localStorage.getItem("nx_op");
    const data3 = localStorage.getItem("nx_ag");

    if (data1 != null) {
      var data = JSON.parse(data1);
      if (data?.organization.organization_type == "CENTRIKA") {
        if (data?.role_name === "AC_GROUP_USER") {
          history.push("/ac_group/home");
          return;
        }
        history.push("/centrika");
      }
    } else if (data2 != null) {
      var data = JSON.parse(data2);
      if (data?.organization.organization_type == "OPERATOR") {
        if(data?.user_type=="AGENT_MANAGER"){
          history.push("/operator/agentmanager/home");
        }else{
          history.push("/operator");
        }
        
      }
    } else if (data3 != null) {
      var data = JSON.parse(data3);
      if (data?.organization.organization_type == "AGENT") {
        history.push("/agent");
      }
    }

  }, []);

  const handleLanguageClose = (code) => {};

  const onUsernameChange = (event) => {
    if (event.target.value === "") {
      setUsername({ value: "", error: "Enter your email or username" });
    } else {
      setUsername({ value: event.target.value, error: "" });
    }
  };

  const onPasswordChange = (event) => {
    if (event.target.value === "") {
      setPassword({ value: "", error: "Enter your password" });
    } else {
      setPassword({ value: event.target.value, error: "" });
    }
  };

  const onLoginClick = (e) => {
    e.preventDefault();

    if (username.value === "") {
      setUsername({ value: "", error: "Enter your email or username here" });
    } else if (password.value === "") {
      setPassword({ value: "", error: "Enter your password here" });
    } else {
      doLogin();
    }
  };

  //////////////////////

  const [tempToken,setTempToken] = useState("");

  const doLogin = () => {

    const loginInstance = axios.create({
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": process.env.REACT_APP_ORIGIN,
      },
    });
    setLogging(true);

    const data = {
      user_name: username.value,
      user_password: password.value,
      device_type:"OTHER"
    };


    loginInstance
      .post(new AdminService().LOGIN, data)
      .then(function (response) {
        setLogging(false);



        if (response.data.status === 401) {
          enqueueSnackbar("You password is expired! Please change it now", {
            variant: "error",
            action: (k) => (
              <IconButton
                onClick={() => {
                  closeSnackbar(k);
                }}
                size="small"
              >
                <Close fontSize="small" />
              </IconButton>
            ),
          });

          setTempToken(response.data.data.token)
          setChangeDialog(true);



          return;
        }

        if (
          (response.data.data.user_type != "ORG_USER" &&
          response.data.data.organization.organization_type != "CENTRIKA" &&
          response.data.data.organization.organization_type != "AGENT" && 
          response.data.data.user_type!="AGENT_MANAGER") || (response.data.data.organization.organization_type == "AGENT" && response.data.data.user_type=="AGENT")
        ) {
          enqueueSnackbar("You are not allowed to use this system", {
            variant: "error",
            action: (k) => (
              <IconButton
                onClick={() => {
                  closeSnackbar(k);
                }}
                size="small"
              >
                <Close fontSize="small" />
              </IconButton>
            ),
          });

          return;
        }





        enqueueSnackbar("Logged in successfuly", {
          variant: "success",
          action: (k) => (
            <IconButton
              onClick={() => {
                closeSnackbar(k);
              }}
              size="small"
            >
              <Close fontSize="small" />
            </IconButton>
          ),
        });
        switch (response.data.data.organization.organization_type) {
          case "CENTRIKA":
            if (response.data.data.user_type == "AGENT") {
              localStorage.setItem(
                "nx_ind",
                JSON.stringify(response.data.data)
              );
              history.push("/individual");
            } else {
              localStorage.setItem(
                "nx_cent",
                JSON.stringify(response.data.data)
              );
              if (response.data.data.role_name === "AC_GROUP_USER"){
                history.push("/ac_group/home");
                return;
              }
              history.push("/centrika");
            }
            break;
          case "OPERATOR":
            localStorage.setItem("nx_op", JSON.stringify(response.data.data));
            localStorage.setItem("nx_ag", JSON.stringify(response.data.data));
              get_profile(response.data.data.user_type);
            break;
          case "COOPERATIVE":
              localStorage.setItem("nx_op", JSON.stringify(response.data.data));
              localStorage.setItem("nx_ag", JSON.stringify(response.data.data));
                get_profile(response.data.data.user_type);
              break;
          case "AGENT":
          
            localStorage.setItem("nx_ag", JSON.stringify(response.data.data));

            // for temporaly use 

            localStorage.setItem("nx_op", JSON.stringify(response.data.data));
          
            if(response.data.data.user_type==="AGENT_MANAGER"){
              get_profile(response.data.data.user_type);
            }else{
              localStorage.setItem("nx_ag", JSON.stringify(response.data.data));
              get_agent_profile();
            }

            
           break;
          case "OPERATOR_AGENCY":
              localStorage.setItem(
                "nx_ag",
                JSON.stringify(response.data.data)
              );
              history.push("/agent");

            break;
          default:
            enqueueSnackbar("Unimplemeted or unknown organization", {
              variant: "warning",
              action: (k) => (
                <IconButton
                  onClick={() => {
                    closeSnackbar(k);
                  }}
                  size="small"
                >
                  <Close fontSize="small" />
                </IconButton>
              ),
            });
        }
      })
      .catch(function (error) {
     
        setLogging(false);
        var e = error.message;

        if (error.response) {
          e = error.response.data.message;
        }

        //console.log(error.response);

        enqueueSnackbar(e, {
          variant: "error",
          action: (k) => (
            <IconButton
              size="small"
              onClick={() => {
                closeSnackbar(k);
              }}
            >
              <Close fontSize="small" />
            </IconButton>
          ),
        });

      });
  };

  // get profile
  const get_profile = (user_type) => {
    

    if(user_type==="AGENT_MANAGER"){
      const data = JSON.parse(localStorage.getItem("nx_ag"));
      axios.defaults.baseURL = new AdminService().BASE_URL;
      const profileInstance = axios.create(new AdminService().getHeaders(data["token"]));
      profileInstance.get("/api/v1/user/"+data['user_id']).then((res) => {
        if (res.status == 200) {
          localStorage.setItem("profile_manager", JSON.stringify(res.data.data));
          history.push("/operator/agentmanager/home");
        }
      });
    }else{
      const data = JSON.parse(localStorage.getItem("nx_op"));
      axios.defaults.baseURL = new TransportService().BASE_URL;
      const profileInstance = axios.create(new TransportService().setHeaders(data["token"]));
      profileInstance.get("/api/v1/integrations/loggedIn").then((res) => {
        if (res.status == 200) {
          localStorage.setItem("profile", JSON.stringify(res.data.data));
  
          history.push("/operator");
        }
      });
    }

  };

  // get agent profile
  const get_agent_profile = (dt) => {
    const data = JSON.parse(localStorage.getItem("nx_ag"));

    

    axios.defaults.baseURL = new FinanceService().BASE_URL;
    const profileInstance = axios.create(new FinanceService().setHeaders(data["token"]));

    // const profileInstance = axios.create({
    //   baseURL: process.env.REACT_APP_FINANCE_URL,
    //   headers: {
    //     Authorization: "Bearer " + data["token"],
    //     "Content-Type": "application/json",
    //     "Access-Control-Allow-Origin": "*",
    //   },
    // });


    profileInstance
      .get(
        "/api/v1/getAgentByOrganizationId/" +
          data["organization"]["organization_id"]
      )
      .then((res) => {
        if (res.status == 200) {
          localStorage.setItem("agent_profile", JSON.stringify(res.data.data));
          history.push("/agent");
        }
      });
  };

    // get agent profile
    const get_manager_profile = (dt) => {
      const data = JSON.parse(localStorage.getItem("nx_ag"));
      const profileInstance = axios.create({
        baseURL: process.env.REACT_APP_FINANCE_URL,
        headers: {
          Authorization: "Bearer " + data["token"],
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
      });
      profileInstance
        .get(
          "/api/v1/getAgentByOrganizationId/" +
            data["organization"]["organization_id"]
        )
        .then((res) => {
          if (res.status == 200) {
            localStorage.setItem("agent_profile", JSON.stringify(res.data.data));
            history.push("/agent");
          }
        });
    };


  /////////////

  const notify = (variant, msg, status) => {
    if (status == 401) {
      history.push("/", { expired: true });
    }
    enqueueSnackbar(msg, {
      variant: variant,
      action: (k) => (
        <IconButton
          onClick={() => {
            closeSnackbar(k);
          }}
          size="small"
        >
          <Close fontSize="small" />
        </IconButton>
      ),
    });
  };

  const initiateReset = () => {
    const createInstance = axios.create();

    setConfirming(true);

    createInstance
      .post(new AdminService().INITIATE_RESET_PASSWORD+"?user_name="+username.value)
      .then(function (response) {
        setConfirming(false);

        const d = response.data;
        notify("success", "Check email sent to your email address for instructions to reset your password.");

      })
      .catch(function (error) {
        setConfirming(false);

        var e = error.message;
        if (error.response) {
          e = error.response.data.message;
        }

        enqueueSnackbar(e, {
          variant: "error",
          action: (k) => (
            <IconButton
              size="small"
              onClick={() => {
                closeSnackbar(k);
              }}
            >
              <Close fontSize="small" />
            </IconButton>
          ),
        });
      });
  };

  //  change password dialog

  const [changeDialog, setChangeDialog] = useState(false);

  const [changePasswordDialog, setChangePasswordDialog] = useState(false);
  const [newPassword, setNewPassword] = useState({ value: "", error: "" });
  const [oldPassword, setOldPassword] = useState({ value: "", error: "" });

  const [changeLoad, setChangeLoad] = useState(false);

  const change_password = () => {
    if (oldPassword.value == "") {
      setOldPassword({ value: "", error: "Enter valid password" });
    } else if (newPassword.value == "") {
      setNewPassword({ value: "", error: "Enter valid password" });
    } else {
      setChangeLoad(true);
      axios.defaults.baseURL = new AdminService().BASE_URL;
      const changeInstance = axios.create(new AdminService().getHeaders(tempToken));
      changeInstance.put('/api/v1/user/changePassword', {
        "new_password": newPassword.value,
        "old_password": oldPassword.value
      })
        .then(res => {
          enqueueSnackbar("Password changed successful!", {
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
            },
          });
          setChangeDialog(false);
          setChangeLoad(false);
        })
        .catch(err => {
          setChangeLoad(false);
          if (err.response) {
            enqueueSnackbar(err.response.data.message, {
              variant: 'error',
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
              },
            });
          }
        });
    }

  }


  return (
    <div className={classes.root}>
      <CssBaseline />

      <Dialog
        open={expired}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Session expired"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Your login session has expired, please login again to continue.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              localStorage.removeItem("nx_cent");
              setExpired(false);
            }}
            color="primary"
          >
            Close
          </Button>
          <Button
            onClick={() => {
              localStorage.removeItem("nx_cent");
              setExpired(false);
            }}
            color="primary"
          >
            Login again
          </Button>
        </DialogActions>
      </Dialog>

      <AppBar position="static" elevation={0} color="primary">
        <Toolbar>
          <img src={LogoWhite} alt="Icon" height={50} />
          <Box className={classes.title} ml={2}>
          
              <Typography variant="h5">SafariBus</Typography>
           
          </Box>
          <LanguageToggleMenu close={handleLanguageClose} />
        </Toolbar>
      </AppBar>

      <Container maxWidth="sm">
        <form onSubmit={onLoginClick}>
          <Box pt={10}>
            <Paper className={classes.paper}>
              <Box p={2} display="flex" flexDirection="column">
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Box mr={2}>
                    <AccountCircle color="primary" fontSize="large" />
                  </Box>
                  <Typography variant="h4">
                    <Translate id="login.hello" />
                  </Typography>
                </Box>
                <Typography color="textSecondary" align="center">
                  <Translate id="login.welcome" />
                </Typography>
              </Box>
              <Box mt={7}>
                <Translate>
                  {({ translate }) => (
                    <TextField
                      size="small"
                      variant="outlined"
                      color="primary"
                      placeholder={translate("login.forms.hints.username")}
                      label={<Translate id="login.forms.labels.username" />}
                      fullWidth
                      onChange={onUsernameChange}
                      helperText={username.error}
                      error={username.error !== ""}
                    />
                  )}
                </Translate>
              </Box>
              <Box mt={2}>
                <Translate>
                  {({ translate }) => (
                    <TextField
                      size="small"
                      variant="outlined"
                      color="primary"
                      placeholder={translate("login.forms.hints.password")}
                      label={<Translate id="login.forms.labels.password" />}
                      type={passSecure ? "password" : "text"}
                      fullWidth
                      onChange={onPasswordChange}
                      helperText={password.error}
                      error={password.error !== ""}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            onClick={() => setPassSecure(!passSecure)}
                          >
                            <IconButton>
                              {" "}
                              {!passSecure ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                </Translate>
              </Box>

              <Box mt={2} mb={2}>
                {" "}
                <FormControlLabel
                  control={<Checkbox name="remember" />}
                  label={<Translate id="login.forms.remember_me" />}
                />
              </Box>

              <Box mt={2} mb={2}>
                <Button
                  type="submit"
                  color="primary"
                  fullWidth
                  variant="contained"
                  disableElevation
                  disabled={logging}
                  onClick={onLoginClick}
                >
                  {logging ? (
                    <CircularProgress size={25} />
                  ) : (
                    <Translate id="login.forms.login" />
                  )}
                </Button>
              </Box>
              <Button fullWidth color='primary' onClick={()=>{

             if(username.value==''){
                notify("warning","Enter your username only to initiate password reset",403)
             }else{
               initiateReset()
             }
              
              }} className={classes.btn} disabled={confirming}> {confirming ? (
                    <CircularProgress size={25} />
                  ) : (
                    "Reset password?"
                  )}</Button>
            </Paper>
          </Box>
        </form>
      </Container>

      {/* change password  */}



      <Dialog
        maxWidth="sm"
        fullWidth
        open={changeDialog}
        onClose={() => {

          setChangeDialog(false);

        }}
        aria-labelledby="change_password"
        aria-describedby="change_password"
      >
        <DialogTitle id="change_password">{"Your password is expired"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            <Box>
              <Box display='flex' alignItems='center' justifyContent='center'>
                <TextField size='small' type="password" variant='outlined' label={"Old Password"} fullWidth
                  onChange={(e) => {
                    if (e.target.value === "") {
                      setOldPassword({ value: "", error: "Enter valid password" })
                    } else {
                      setOldPassword({ value: e.target.value, error: "" });
                    }
                  }}
                  error={oldPassword.error !== ""}
                  helperText={oldPassword.error} />
              </Box>


              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                <TextField size='small' type="password" variant='outlined' label={"New Password"} fullWidth
                  onChange={(e) => {
                    if (e.target.value === "") {
                      setNewPassword({ value: "", error: "Enter valid New password" })
                    } else {
                      setNewPassword({ value: e.target.value, error: "" });
                    }
                  }}
                  error={newPassword.error !== ""}
                  helperText={newPassword.error} />
              </Box>

            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>

          <Button onClick={() => {

            setChangeDialog(false);

          }} color="secondary" variant="outlined" >
            close
          </Button>

          <Button color="primary" onClick={() => {

            change_password();

          }} variant="contained" >
            {changeLoad ? <CircularProgress size={25} color="secondary" /> : "Save"}
          </Button>

        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withLocalize(Login);